import React, { useState, useEffect } from 'react';

import { userActions } from '../../actions';

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

function Registration() {
  const [user, setUser] = useState({
    nom: '',
    prenom: '',
    email: '',
    pass: '',
    passConfirm: ''
  });

  const userRegistered = useSelector(state => state.registration.userRegistered);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userActions.logout());
  }, [dispatch]);

  function handleChange(e) {
    const { name, value } = e.target;
    setUser(user => ({ ...user, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (isValidForm()) {
      dispatch(userActions.register(user));
    }
  }

  function isValidForm() {
    return user.nom && user.prenom && user.email && user.pass && user.passConfirm;
  }

  return (
    <div className="inscription">
      <Link to="/login" className="btn--link has-gris-fonce-color bold"> &lt; Retour à la connexion</Link>
      <h2>Inscription</h2>
      {userRegistered &&
        <div>
          <p>Un email de confirmation vous a été envoyé afin de valider votre adresse email et activer votre compte.</p>
          <p>Une fois votre inscription validée, vous pourrez vous connecter et accèder à votre compte.</p>
        </div>
      }
      {!userRegistered &&
        <form className="form form--registration" noValidate onSubmit={handleSubmit}>
          <p>Veuillez renseigner les informations ci-dessous afin de valider votre inscription.</p>
          <div className="form-group">
            <label htmlFor="nom">Nom</label>
            <input type="text" id="nom" name="nom" value={user.nom} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="prenom">Prénom</label>
            <input type="text" id="prenom" name="prenom" value={user.prenom} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" value={user.email} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="pass">Mot de passe</label>
            <input type="password" id="pass" name="pass" value={user.pass} onChange={handleChange} />
            <span className="info">6 caractères minimum</span>
          </div>
          <div className="form-group">
            <label htmlFor="passConfirm">Confirmation du mot de passe</label>
            <input type="password" id="passConfirm" name="passConfirm" value={user.passConfirm} onChange={handleChange} />
            <span className="info">6 caractères minimum</span>
          </div>
          <button disabled={!isValidForm()} className="btn btn--no-icon">Valider mon inscription</button>
        </form>
      }
    </div>
  );
}

export default Registration;
